import { render } from "./MagasinViews.vue?vue&type=template&id=24ee39de&scoped=true"
import script from "./MagasinViews.vue?vue&type=script&lang=js"
export * from "./MagasinViews.vue?vue&type=script&lang=js"

import "./MagasinViews.vue?vue&type=style&index=0&id=24ee39de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ee39de"]])

export default __exports__